<template>
  <v-container>
    <v-overlay :absolute="absolute" :value="overlay" z-index="1000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col>
        <v-banner elevation="1">Clientes</v-banner>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="text-center">
          <v-text-field
            label="Buscar"
            placeholder="Cliente..."
            v-model="searchClient"
            @keyup="filterClients()"
          ></v-text-field>
        </div>
      </v-col>
      <v-col>
        <div class="text-center float-right">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                fab
                small
                icon
                @click="showNew()"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>
                  mdi-account-multiple-plus
                </v-icon>
              </v-btn>
            </template>
            <span>Agregar Cliente</span>
          </v-tooltip>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-sheet elevation="1">
          <v-progress-linear
            indeterminate
            color="primary"
            v-if="loading"
          ></v-progress-linear>
          <v-simple-table cols="auto" elevation="9">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">
                    ID
                  </th>
                  <th class="text-center">
                    Nombre
                  </th>
                  <th class="text-center">
                    Descripción
                  </th>
                  <th class="text-center">
                    Opciones
                  </th>
                </tr>
              </thead>
              <template v-if="clients.length">
                <tbody>
                  <tr
                    class="text-center"
                    v-for="client in clients"
                    :key="client.id"
                  >
                    <td>{{ client.id }}</td>
                    <td>{{ client.name }}</td>
                    <td>{{ client.description }}</td>
                    <td>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            fab
                            small
                            icon
                            @click="showDelete(client)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon>
                              mdi-delete
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Eliminar</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
              <template v-else>
                <div class="float-right pa-4">
                  No hay registros
                </div>
              </template>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogDelete" scrollable max-width="420px">
      <v-card min-width="100%">
        <v-card-title>Eliminar Usuario</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          ¿está seguro que desea eliminar el cliente {{ clientDelete.id }}?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey darken-1" text @click="dialogDelete = false">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="warning float-right"
            text
            @click="deleteClient(clientDelete)"
          >
            Si
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNew" scrollable max-width="420px">
      <v-card min-width="100%">
        <v-card-title>Crear Cliente:</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <v-form v-model="validNew">
            <v-container>
              <v-row>
                <v-col cols="12" class="px-8 pt-6">
                  <v-text-field
                    v-model="clientNew.id"
                    :rules="idRules"
                    :counter="24"
                    label="ID"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="px-8 pt-6">
                  <v-text-field
                    v-model="clientNew.name"
                    :rules="nameRules"
                    :counter="24"
                    label="Nombre"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="px-8">
                  <v-text-field
                    v-model="clientNew.description"
                    label="Descripción"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey darken-1" text @click="dialogNew = false">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary float-right"
            text
            @click="saveClientNew()"
            :disabled="!validNew"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="alertSnackbar" :timeout="3000" top>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="alertSnackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { Config } from "../config";
export default {
  data() {
    return {
      loading: false,
      overlay: true,
      absolute: true,
      clientNew: {
        name: "",
        id: "",
        description: ""
      },
      clientDelete: {},
      dialogNew: false,
      validNew: false,
      alertSnackbar: false,
      snackbarText: "",
      clients: [],
      searchClient: "",
      valid: false,
      show: false,
      nameRules: [
        v => !!v || "El nombre no puede estar vacío",
        v => v.length >= 4 || "El nombre debe ser mayor a 4 caracteres",
        v => v.length <= 25 || "El nombre debe ser menor a 24 caracteres"
      ],
      idRules: [
        v => !!v || "El ID no puede estar vacío",
        v => v.length >= 3 || "El ID debe ser mayor a 3 caracteres",
        v => v.length <= 25 || "El ID debe ser menor a 24 caracteres",
        v => /^\d+$/.test(v) || "ID no es válido"
      ],
      dialogDelete: false
    };
  },
  mounted() {
    this.getClients();
  },
  computed: {},
  methods: {
    getClients() {
      this.overlay = true;
      let url = Config.url + "/db/clients";
      this.axios
        .get(url)
        .then(res => {
          this.clients = res.data.clients;
        })
        .catch(err => {
          console.log(err);
          this.snackbarText =
            "Error en servidor, falló al tratar de obtener lista de Clientes";
          this.alertSnackbar = true;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showNew() {
      this.dialogNew = true;
    },
    showDelete(client) {
      this.dialogDelete = true;
      this.clientDelete = client;
    },
    deleteClient(client) {
      this.overlay = true;
      this.dialogDelete = false;
      let url = Config.url + "/db/client/" + client.id;
      this.axios
        .delete(url)
        .then(res => {
          if (res.status == 200) {
            this.snackbarText = "Cliente eliminado exitosamente";
            this.alertSnackbar = true;
            this.getClients();
          }
        })
        .catch(err => {
          console.log(err);
          this.snackbarText =
            "Ocurrió un error al eliminar cliente, intente más tarde";
          this.alertSnackbar = true;
          this.getClients();
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    saveClientNew() {
      this.overlay = true;
      this.dialogNew = false;
      let url = Config.url + "/db/client";
      let params = this.clientNew;
      this.clientNew.id = parseInt(this.clientNew.id);
      this.axios
        .post(url, params)
        .then(res => {
          if (res.status == 201) {
            this.snackbarText = "Cliente guardado exitosamente";
            this.alertSnackbar = true;
            this.clientNew = {
              id: "",
              name: "",
              description: ""
            };
            this.getClients();
          }
        })
        .catch(err => {
          if (err.response.status == 409) {
            this.snackbarText = `Cliente ID: ${this.clientNew.id} ya existe`;
          } else {
            this.snackbarText =
              "Ocurrió un error al guardar cliente, es posible que ya exista un cliente con este ID/Nombre";
          }
          this.alertSnackbar = true;
          this.getClients();
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    filterClients() {
      this.loading = true;
      if (this.searchClient != "") {
        let url = Config.url + "/db/clients";
        this.axios
          .get(url)
          .then(res => {
            this.clients = res.data.clients;
            let arrayFilterUsers = [];
            let searchClient = this.searchClient.toLowerCase();
            this.clients.map(item => {
              let id = new String(item.id);
              let name = item.name.toLowerCase();
              let description = item.description
                ? item.description.toLowerCase()
                : "";
              if (
                id.search(searchClient) != -1 ||
                name.search(searchClient) != -1 ||
                description.search(searchClient) != -1
              ) {
                arrayFilterUsers.push(item);
              }
            });
            this.clients = arrayFilterUsers;
          })
          .catch(err => {
            console.log(err);
            this.snackbarText = "Ocurrió un error, intente más tarde";
            this.alertSnackbar = true;
          });
      } else {
        this.getClients();
      }
      this.loading = false;
    }
  }
};
</script>

<style></style>
